import { makeStyles } from "@material-ui/core";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React from "react";

function a11yProps(name, index) {
  return {
    id: `${name}-tab-${index}`,
    "aria-controls": `${name}-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    justifyContent: "center",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      minHeight: "54px",
      paddingLeft: theme.spacing(4),
    },
  },
  tabRoot: {
    padding: " 1px 7px 2px 1px",
    borderRadius: "4px",
    color: "#2c3687",
    minHeight: "31px",
    alignItems: "center",
    minWidth: "110px",
    fontSize: "13px",
    textTransform: "capitalize",
    "&.Mui-selected": {
      backgroundColor: "#f3f6f9",
      color: "#2c3687",
      fontWeight: theme.typography.fontWeightMedium,
      outline: 0,
    },
    [theme.breakpoints.down("md")]: {
      "&.Mui-selected": {
        backgroundColor: "transparent",
      },
    },
  },
  indicator: {
    backgroundColor: "transparent",
    [theme.breakpoints.down("md")]: {
      marginTop: theme.spacing(3),
      backgroundColor: "#443092",
    },
  },
  tabs: {
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      alignItems: "normal",
      paddingTop: theme.spacing(1.6),
    },
  },
}));

const TabbedHeader = (props) => {
  const { tabList = [], ariaLabel = "", handleChange, value } = props;
  const classes = useStyles();

  return (
    <div>
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ className: classes.indicator }}
        aria-label={ariaLabel}
        className={`${classes.tabs}`}
      >
        {tabList.map((tab, index) => {
          return (
            <Tab
              key={tab}
              className={classes.tabRoot}
              label={tab}
              {...a11yProps(tab, index)}
            />
          );
        })}
      </Tabs>
    </div>
  );
};

export default TabbedHeader;
